import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.447 27.807C25.907 25.747 29 21.235 29 16c0-7.18-5.82-13-13-13S3 8.82 3 16c0 5.235 3.094 9.747 7.553 11.807q.03.016.061.028A12.95 12.95 0 0 0 16 29a12.95 12.95 0 0 0 5.447-1.193M16 5C9.925 5 5 9.925 5 16a10.99 10.99 0 0 0 5 9.221V19a2 2 0 0 1 2-2v-5a1 1 0 0 1 .553-.894l6-3A1 1 0 0 1 20 9v8a2 2 0 0 1 2 2v6.221c3.01-1.963 5-5.36 5-9.221 0-6.075-4.925-11-11-11m4 21.25V19h-8v7.25c1.24.484 2.589.75 4 .75s2.76-.266 4-.75M14 17h4v-6.382l-4 2z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconHighlighterCircle = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconHighlighterCircle);
export default Memo;
